<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay" md="12">
    <v-row class="justify-center">
      <v-col cols="12" md="8">
        <v-card class="mb-6">
          <v-card-title>Create a new Client</v-card-title>
          <v-form @submit.prevent="submit" @reset="handleReset">
            <v-card-text>
              <v-text-field
                v-model="form.name.value.value"
                :error-messages="form.name.errorMessage.value"
                label="Name used to identify the Client"
              />
              <v-text-field
                v-model="form.email.value.value"
                :error-messages="form.email.errorMessage.value"
                label="Email"
              />
              <v-text-field
                v-model="form.pennylane_id.value.value"
                :error-messages="form.pennylane_id.errorMessage.value"
                label="Pennylane Client ID"
              />
              <v-autocomplete
                label="Managed Parks"
                :items="parks"
                multiple
                chips
                v-model="form.parks.value.value"
                :error-messages="form.parks.errorMessage.value"
                item-title="name"
                item-value="id"
              />
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn type="reset">Reset</v-btn>
              <v-btn type="submit" variant="elevated" color="green">Submit</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </PanelPage>
</template>

<script setup>
import PanelPage from "@/components/PanelPage.vue";
import { onMounted, ref } from "vue";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { getFormFromSchema } from "../utils.js";
import { createClient } from "@/remote/client";
import { fetchParks } from "@/remote/park";

// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);
const parks = ref();

// Validation Schema
const schema = yup.object({
  name: yup.string().required(),
  email: yup.string().email(),
  pennylane_id: yup.string(),
  parks: yup.array().required(),
});

const { handleSubmit, handleReset } = useForm({
  validationSchema: schema,
});

const form = getFormFromSchema(schema);

const submit = handleSubmit(async (values) => {
  console.log(values);
  loadingOverlay.value = true;
  // Create Client
  try {
    await createClient(useAlerts, values);
  } catch (e) {
    console.log(e);
  } finally {
    loadingOverlay.value = false;
  }
});

onMounted(async () => {
  loadingOverlay.value = true;
  try {
    parks.value = await fetchParks();
  } catch (e) {
    useAlerts.value.errorAlert('Impossible to load parks info', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
});

</script>

<style scoped>

</style>
